import create, { SetState, State, StateCreator, StoreApi } from 'zustand'
import { devtools } from 'zustand/middleware'

export function createStore<T extends State>(
  name: string,
  store: StateCreator<T, SetState<T>> | StoreApi<T>
) {
  if (process.env.NODE_ENV === 'production') {
    return create<T>(store)
  }

  return create<T>(devtools(store as any, name))
}
